const athleteEvent = state => state.athleteEvent;

const athleteListEvent = state => state.athleteListEvent;

const athleteEvents = state => state.athleteEvents;

const athleteListEvents = state => state.athleteListEvents;

const athleteEventLoading = state => state.athleteEventLoading;

const athleteEventsLoading = state => state.athleteEventsLoading;

export default {
  athleteEvent,
  athleteListEvent,
  athleteEvents,
  athleteListEvents,
  athleteEventLoading,
  athleteEventsLoading
};
